<template>
  <div id="app">
    <router-view name="header"/>
    <div class="wrapper">
      <router-view/>
    </div>
    <router-view name="footer" type="fixed"/>
  </div>
</template>
<script>
export default {
  created() {
    this.$store.dispatch('loadConfig')
  }
};
</script>
